import { UserPermissionsModule } from './../user-permissions/user-permissions.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared';
import { UserModule } from '../user';
import { GlobalPopupModule } from '../global-popup';
import { DocumentsModule } from '../documents/documents.module';
import { HeaderTitleModule } from '../header-title/header-title.module';
import { NotificationBarModule } from '../notification-bar/notification-bar.module';
import { LayoutModule } from '../layout/layout.module';
import { ToolbarMenuModule } from '../toolbar-menu/toolbar-menu.module';
import { STHeaderComponent } from './home/st-header.component';
import { STWorkspaceLevelLayoutComponent } from './home/st-workspace-level-layout.component';
import { SampleTrackingNavigationComponent } from './navigation/sample-tracking-navigation.component';
import { SampleTrackingLinksInfoStorage } from './navigation/sample-tracking-links-info-storage';
import { SampleTrackingLevelComponent } from './sample-tracking-level.component';
import { SampleTrackingGuard } from './sample-tracking-guard';
import { SampleTrackingDashboardComponent } from './dashboard/sample-tracking-dashboard.component';
import { SampleTrackingPreferencesComponent } from './user-preferences/sample-tracking-preferences.component';
import { StudyGroupListComponent } from './group-info/study-group-list.component';
import { StudyGroupCardComponent } from './group-info/study-group-card.component';
import { CreateStudyGroupComponent } from './create-study-group/create-study-group.component';
import { SampleTrackingStorage } from './sample-tracking-storage';
import { TextHighlightService } from './service/text-highlight/text-highlight-service';
import { MessageDialogComponent } from './service/dialog-service/message-dialog/message-dialog.component';
import { SampleTrackingDialogService } from './service/dialog-service/sample-tracking-dialog-service';
import { ViewStudyGroupComponent } from './view-study-group/view-study-group.component';
import { DeleteStudyGroupComponent } from './delete-study-group/delete-study-group.component';
import { SampleTrackingActionService } from './service/sample-tracking-action-service';
import { ProtocolsComponent } from './dashboard/protocols/protocols.component';
import { SamplesSearchComponent } from './shared/samples-search/samples-search.component';
import { OverviewDashboardComponent } from './dashboard/overview-dashboard/overview-dashboard.component';
import { SampleStatusComponent } from './dashboard/overview-dashboard/sample-status/sample-status.component';
import { EditStudyGroupComponent } from './edit-study-group/edit-study-group.component';
import { VisitDetailsComponent } from './tracking-overview/visit-details/visit-details.component';
import { VisitOverviewComponent } from './tracking-overview/visit-overview/visit-overview.component';
import { SampleOverviewComponent } from './tracking-overview/sample-overview/sample-overview.component';
import { CovanceSelectModule } from '../covance-select/covance-select.module';
import { SampleTrackingSelectComponent } from './shared/sample-tracking-select/sample-tracking-select.component';
import { MyDatePickerModule } from 'mydatepicker';
import { SampleTrackingSelectFilterService } from './shared/sample-tracking-select/sample-tracking-select-filter-service';
import { SampleStatusService } from './dashboard/overview-dashboard/sample-status/sample-status-service';
import { SampleTrackingGridComponent } from './shared/sample-tracking-grid/sample-tracking-grid.component';
import { SampleTrackingFilterSamplesComponent } from './filter-samples/st-filter-samples.component';
import { SampleColumnsService } from './filter-samples/column/sample-column-service';
import { SamplesDataDownloadService } from './filter-samples/column/samples-data-download-service';
import { SampleTrackingAgExportComponent } from './shared/sample-tracking-grid/sample-tracking-ag-export.component';
import { CovanceDatePickerModule } from '../covance-date-picker/covance-date-picker.module';
import { TrackingOverviewService } from './tracking-overview/service/tracking-overview.service';
import { ContainerRendererComponent } from './filter-samples/column/container-number-column-renderer';
import { AccessionRendererComponent } from './filter-samples/column/accession-number-column-renderer';
import { SampleDetailsComponent } from './tracking-overview/sample-details/sample-details.component';
import { SampleActivityComponent } from './tracking-overview/sample-activity/sample-activity.component';
import { AppBreadcrumbComponent } from './shared/breadcrumb-service/breadcrumb.component';
import { BreadcrumbService } from './shared/breadcrumb-service/breadcrumb.service';
import { SampleTrackingReportsComponent } from './reports/sample-tracking-reports.component';
import { SampleTrackingReportTypesComponent } from './reports/report-types/report-types.component';
import { ReportActionRendererComponent } from './reports/report-grid/report-column-renderer/action-renderer.component';
import { ReportTrackingGridComponent } from './reports/report-grid/report-grid.component';
import { ReportColumnsService } from './reports/services/report-columns-service';
import { ReportsStorageService } from './reports/services/reports-storage-service';
import { ScheduledReportGridComponent } from './reports/report-grid/scheduled-report-grid/scheduled-report-grid.component';
import { GeneratedReportGridComponent } from './reports/report-grid/generated-report-grid/generated-report-grid.component';
import { MyFiltersComponent } from './shared/my-filters/my-filters.component';
import { SamplesHelperService } from './filter-samples/service/samples-helper-service';
import { ScheduleReportComponent } from './reports/new-report/schedule-report/schedule-report.component';
import { NewReportComponent } from './reports/new-report/new-report.component';
import { FilterOptionsComponent } from './reports/new-report/filters/filter-options.component';
import { ViewGeneratedReportsComponent } from './reports/view-reports/generated-reports/view-generated-reports.component';
import { ViewScheduledReportsComponent } from './reports/view-reports/scheduled-reports/view-scheduled-reports.component';
import { SampleTrackingReportsLoaderComponent } from './reports/sample-tracking-report-loader';
import { NavigationServiceComponent } from './service/navigation-service/navigation-service.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DeleteReportComponent } from './reports/delete-report/delete-report.component';
import { SampleTrackingUserSettings } from './user-preferences/user-settings/user-settings.component';
import { SiteShippingToolModule } from '../site-shipping-tool/site-shipping-tool.component.module';
import { AppDashboardSearchComponent } from './dashboard/dashboard-search/dashboard-search.component';
import { SampleSearchService } from './shared/samples-search/sample-search-service';
import { SubjectSearchOverviewComponent } from './tracking-overview/subject-search-overview/subject-search-overview.component';
import { SubjectSearchService } from './tracking-overview/subject-search-overview/subject-search-service';
import { SubjectVisitDetailsComponent } from './tracking-overview/subject-details/subject-visit-details.component';
import { SampleMonitoringComponent } from './sample-monitoring/sample-monitoring.component';
import { SampleMonitoringNotificationsComponent } from './sample-monitoring/sample-monitoring-notifications/sample-monitoring-notifications.component';
import { SampleMonitoringNotificationRulesComponent } from './sample-monitoring/sm-notification-rules/sm-notification-rules.component';
import { SMNotificationRuleFormComponent } from './sample-monitoring/notification-form/sm-notification-rule-form.component';
import { SampleMonitoringService } from './sample-monitoring/service/sample-monitoring-service';
import { SampleMonitoringStorage } from './sample-monitoring/service/sample-monitoring-storage';
import { GlobalErrorHandler } from '../core/global-error-handler';
import { DynamicListViewComponent } from './filter-samples/dynamic-list-view.component';
import { DataChangeModelComponent } from './shared/data-change-model/data-change-model.component';
@NgModule({
    declarations: [
        AppBreadcrumbComponent,
        SampleTrackingLevelComponent,
        SampleTrackingNavigationComponent,
        STWorkspaceLevelLayoutComponent,
        STHeaderComponent,
        SampleTrackingDashboardComponent,
        SampleTrackingPreferencesComponent,
        StudyGroupListComponent,
        StudyGroupCardComponent,
        CreateStudyGroupComponent,
        MessageDialogComponent,
        ViewStudyGroupComponent,
        DeleteStudyGroupComponent,
        ProtocolsComponent,
        SamplesSearchComponent,
        OverviewDashboardComponent,
        SampleStatusComponent,
        EditStudyGroupComponent,
        //SampleTrackingSelectComponent,
        EditStudyGroupComponent,
        VisitOverviewComponent,
        VisitDetailsComponent,
        SampleOverviewComponent,
        SampleTrackingGridComponent,
        SampleTrackingFilterSamplesComponent,
        SampleTrackingAgExportComponent,
        ContainerRendererComponent,
        AccessionRendererComponent,
        SampleDetailsComponent,
        MyFiltersComponent,
        ScheduleReportComponent,
        NewReportComponent,
        FilterOptionsComponent,
        SampleTrackingReportsComponent,
        SampleTrackingReportTypesComponent,
        ReportActionRendererComponent,
        ReportTrackingGridComponent,
        ViewGeneratedReportsComponent,
        ViewScheduledReportsComponent,
        GeneratedReportGridComponent,
        ScheduledReportGridComponent,
        MyFiltersComponent,
        SampleTrackingReportsLoaderComponent,
        DeleteReportComponent,
        SampleTrackingUserSettings,
        AppDashboardSearchComponent,
        SubjectSearchOverviewComponent,
        SubjectVisitDetailsComponent,
        SampleMonitoringComponent,
        SampleMonitoringNotificationsComponent,
        SampleMonitoringNotificationRulesComponent,
        SMNotificationRuleFormComponent,
        DynamicListViewComponent,
        DataChangeModelComponent
    ],
    imports: [
        SharedModule,
        DocumentsModule,
        UserPermissionsModule,
        GlobalPopupModule,
        ReactiveFormsModule,
        UserModule,
        HeaderTitleModule,
        ToolbarMenuModule,
        NotificationBarModule,
        LayoutModule,
        CovanceSelectModule,
        CovanceDatePickerModule,
        MyDatePickerModule,
        NgxMaterialTimepickerModule,
        BrowserAnimationsModule,
        SiteShippingToolModule
    ],
    providers: [
        SampleTrackingGuard,
        SampleTrackingLinksInfoStorage,
        SampleTrackingStorage,
        ReportColumnsService,
        ReportsStorageService,
        TextHighlightService,
        SampleTrackingDialogService,
        SampleTrackingActionService,
        //SampleTrackingSelectFilterService,
        SampleStatusService,
        SampleColumnsService,
        TrackingOverviewService,
        BreadcrumbService,
        SamplesHelperService,
        SampleSearchService,
        SubjectSearchService,
        SampleMonitoringService,
        SampleMonitoringStorage,
        SamplesDataDownloadService,
        GlobalErrorHandler
    ],
    entryComponents: [
        CreateStudyGroupComponent,
        MessageDialogComponent,
        ViewStudyGroupComponent,
        DeleteStudyGroupComponent,
        EditStudyGroupComponent,
        AccessionRendererComponent,
        ContainerRendererComponent,
        DeleteReportComponent,
        DataChangeModelComponent
    ]
})
export class SampleTrackingModule { }
